export default {
    bms : {
        title : '裸金属服务器',
        common : {
            search : '搜索',
            location : '机房',
            element1 : '选择要筛选的区域',
            element2 : '没有数据，您可以',
            content : '创建一个实例',
            Intranet : '内网' ,
            Pending : '等待中',
            month : '月',
            buybms : '购买裸金属',
            buyip : '购买IP',
            createsevergroup : '创建安全组',
            createintnet : '创建内网',
            copy:'复制',
        },
        list : {
            FirstList : '裸金属',
            SecondList : '安全组',
            ThirdList : 'IP',
            FourthList : '内网',
            SecurityGroupstitle : '安全组 - 裸金属',
            IPtitle : 'IP - 裸金属',
            Intranetstitle : '内网 - 裸金属',
        },
        Instances : {
            searchHolder : '搜索实例ID/名称/IP',
            FirstColumn  : '实例ID/名称/IP',
            SecondColumn : '配置',
            ThirdColumn : '操作系统',
            FourthColumn : '机房',
            FifthColumn : '上架时间',
            SixthColumn : '到期时间',
            SeventhColumn : '价格（美元/月）',
            EighthColumn : {
                title : '状态',
                Unlisted : '未上架',
                Initializing : '上架中',
                Running : '运行中',
                Reinstalling : '重装系统',
                ConfigChanging : '更换配置',
                Disconnected : '已断网',
                Stopped : '已关机',
                // Discontinued : '已终止',
                ZoneChanging : '换机房中',
                Unknown : '未知状态'
            },
            NinthColumn : {
                title : '操作',
                Renew : '续费',
                View  : '查看',
                Rename : '修改名称',
                Start : '开机',
                Restart : '重启',
                Stop : '关机',
                Upgrade : '升级', 
                Upgradebandwidth : '升级带宽', 
                UpgradeTemBandwidth : '升级临时带宽',  
                Reinstall : '重装系统',
                AddReservedIP : '购买IP',
                AddDataDisk : '购买硬盘',
                AddtoIntranet : '加入内网'
            },
            renewpop : {
                title : '续费',
                element1 : '您已选',
                element2 : '配置概览',
                element3 : '公网IP地址',
                element4 : '台裸金属',
                element5 : '台裸金属',
                Duration : '续费时长',
                element1month : '1个月',
                element2months : '2个月',
                element3months : '3个月',
                element6months : '6个月',
                element1year : '1年',
                element2years : '2年',
                Balance : '余额',
                Password : '密码',
                element6 : '请输入登录密码',
                Charges : '续费费用',
                Button1 : '取消',
                Button2 : '购买',
            },
            Viewlist : {
                title:'查看',
                Information : {
                   title : '基本信息',
                   element1 : '裸金属服务器信息',
                   User : '用户',
                   OrderNo : '订单号',
                   InstanceID : '实例ID',
                   Zone : '机房',
                   Charges : '价格',
                   Bandwith : '带宽',
                   Status : '状态',
                   OSCategory : '系统类别',
                   OSVersion : '系统名称',
                   SystemDisk : '硬盘',
                   CreatedTime : '上架时间',
                   ExpiredTime : '到期时间',
                   PublicIP : '公网IP',
                   element2 : '硬盘信息',
                   Model : '型号',
                   UsageStatus:  '状态',
                   Enabled : '启用',
                   Disabled : '禁用',
                   Wait : '正在安装，请稍等'
                },
                Monitoring : {
                    title : '监控',
                    BandwidthMonitoring : '带宽监控',
                    Interval1minute : '间隔时间一分钟',
                    Receive : '接收',
                    SentOut : '发送',
                    element1day :  '全天',
                    element1hour :  '1小时',
                    element30min :  '30分钟',
                    element10min :  '10分钟',
                },
                OperationRecords : {
                    title : '操作日志',
                    ActionName : '操作',
                    UserName : '操作人',
                    IPAddress : 'IP地址',
                    OccurredAt : '操作时间',
                }
            },
            renamepop : {
                title : '改名',
                newname : '新名称：',
                Button1 : '取消',
                Button2 : '改名',
                element1 :'请在此处输入新名称'
            },
            startpop : {
                title : '开机',
                element1 : '您已选',
                element2 : '台裸金属',
                element3 : '台裸金属',
                element4 : '可开机',
                element5 : '不可开机',
                Button1 : '取消',
                Button2 : '开机',
            },
            restartpop : {
                title : '重启',
                element1 : '您已选',
                element2 : '强制关机可能会导致数据丢失或文件系统损坏，请仅在服务器不能正常关机时使用',
                element3 : '确认强制重启',
                element4 : '台裸金属',
                element5 : '台裸金属',
                element6 : '可重启',
                element7 : '不可重启',
                Button1 : '取消',
                Button2 : '重启',
            },
            stoppop : {
                title : '关机',
                element1 : '您已选',
                element2 : '您确定要对这台物理机执行关机操作？关机期间，主机将无法正常提供服务，请您做好准备，以免造成影响',
                element3 : '强制关机可能会导致数据丢失或文件系统损坏，请仅在服务器不能正常关机时使用',
                element4 : '确认使用强制关机',
                element5 : '台裸金属',
                element6 : '台裸金属',
                element7 : '可关机',
                element8 : '不可关机',
                Button1 : '取消',
                Button2 : '关机',
            },
            upgradebandwidthpop : {
                title : '升级带宽',
                CurrentConfiguration:  '原配置:',
                PermanentBandwidth:  '（目标）永久性带宽:',
                Temporary:  '临时',
                element1 : '实例到期后，下次计费周期续费所需费用为',
                element2 : '升级带宽实时生效',
                element3 : '请在此输入登录密码',
                Balance : '余额',
                Password : '密码',
                Charges : '费用',
                Button1 : '取消',
                Button2 : '购买',
            },
            upgradetembandwidthpop : {
                title : '购买临时带宽',
                CurrentBandwidth: '当前带宽数值:',
                BandwidthIncrement : '购买临时带宽数值:',
                Temporary:  '临时',
                Duration : '购买时长:',
                Hour : '小时数',
                Day : '天数',
                Hour_s : '小时',
                Day_s : '天',
                Hours : '小时',
                Days : '天',
                Password : '密码',
                element1 : '请在此输入登录密码',
                Charges : '费用',
                Button1 : '取消',
                Button2 : '购买',
            },
            reinstallpop : {
                title : '重装操作系统',
                element1 : '选择公共镜像:',
                element2 : '操作系统',
                element3 : '选择',
                element4 : '远程账户',
                user : '用户',
                password : '密码',
                element5 : '密码长度必须为 8 到 16 个字符，',
                element6 : '并且必须包含大小写字母和数字，不支持特殊符号。',
                element7 : '重装后，服务器系统盘内的所有数据将被清除，恢复到初始状态。',
                element8 : '单独购买的数据盘需要手动挂载才能使用。',
                Button1 : '取消',
                Button2 : '重装',
            },
            addReservedIPpop : {
                title : '购买IP',
                element1 : '您确认将对',
                element2 : '添加IP',
                element3 : 'IP数量(1~10个):',
                element4 : '调整项目',
                CurrentIP : '原IP数',
                GoalIP : '调整后IP数',
                ValidityPeriod : '到期时间',
                element5 : '本次升级有效期为 ',
                element6 : '下次计费周期续费所需费用为',
                element7 : '每台物理机最少一个公网IP地址',
                element8 : '请在此输入登录密码',
                Balance : '余额',
                Password : '密码',
                Charges : '费用',
                Button1 : '取消',
                Button2 : '购买',
            },
            addDataDiskpop : {
                title : '购买硬盘',
                element1 : '您确认将对',
                element2 : '购买硬盘',
                element3 : '数量(1~10个):',
                element4 : '硬盘类型:',
                element5 : '本次升级有效期为 ',
                element6 : '下次计费周期续费所需费用为',
                element7 : '购买硬盘后，该硬盘会由机房人员手工添加，时间约10分钟-30分钟',
                element8 : '添加硬盘后，需要您在系统时挂载，才可以看到可以使用',
                element9 : '请在此输入登录密码',
                Balance : '余额',
                Password : '密码',
                Charges : '费用',
                Button1 : '取消',
                Button2 : '购买',
            },
            addtoIntranetpop : {
                title : '加入内网',
                Instance : '实例',
                PublicIP : '公网IP',
                element1 : '选择内网：',
                element2 : '相同区域线路的裸金属可通过内网互相访问',
                element3 : '暂无内网，请',
                element4 : '创建一个',
                Button1 : '取消',
                Button2 : '加入',
            },
            addseverpop : {
                title : '加入安全组',
                element1 : '选择安全组',
                element2 : '请选择一个安全组',
                element3 : '选择实例：',
                element4 : '选择了',
                element5 : '个实例',
                element6 : '可加入',
                element7 : '不可加入',
                element8 : '加入后，所选安全组的规则将自动对所选实例生效。',
                element9 : '首次添加到安全组，默认情况下拒绝所有端口，请根据需要添加权限策略规则。',
                element10 : '没有安全组，请',
                element11 : '创建一个',
                Button1 : '取消',
                Button2 : '加入',
            },
            footer : {
                title : '批量操作',
                Renew : '续费',
                AddtoSecurityGroup : '加入安全组',
                Start : '开机',
                Restart : '重启',
                Stop : '关机',
            },
        },
        SecurityGroups : {
            searchHolder : '搜索ID / 安全组名称',
            FirstColumn  : 'ID / 安全组名称',
            SecondColumn : '安全组ID',
            ThirdColumn : '安全组名称',
            FourthColumn : '标签',
            FifthColumn : '关联实例数',
            SixthColumn : '创建时间',
            SeventhColumn : {
                title : '操作',
                Configure : '配置规则',
                Edit  : '修改',
                Delete : '删除',
                delcon : '请在删除安全组之前删除相关实例'
            },
            addSecurityGroups :{
                title : '创建安全组',
                title2 : '编辑安全组',
                name : '名字',
                tags : '标签',
                description : '描述',
                element1 : '2-64字符长度',
                element2 : '用逗号分隔',
                Button1 : '取消',
                Button2 : '确认',
            },
            delSecurityGroups :{
                title : '删除安全组',
                element1 : '你确定要删除?',
                element2 : '所选安全组的列表',
                element3 : '你选择了',
                element4 : '个安全组',
                element5 : '', 
                element6 : '', 
                Button1 : '取消',
                Button2 : '删除',
            },
            Configurelist :{
                InboundRules : {
                    title : '入站规则',
                    FirstColumn  : 'ID / 安全组名称',
                    SecondColumn : '来源',
                    ThirdColumn : '协议类型',
                    FourthColumn : '端口范围',
                    FifthColumn : '策略',
                    SixthColumn : '备注',
                    SeventhColumn : '优先级',
                    Allowed : '允许',
                    NotAllowed : '不允许',
                    EighthColumn : {
                        title : '操作',
                        modify : '编辑',
                        delete : '删除',
                    },
                    addButton : {
                        title : '添加规则',
                        element1 : '首次加入安全组，默认拒绝所有端口，请按需要添加允许策略规则',
                        element2 : '来源格式：所有IP（0.0.0.0） 单个IP（10.x.x.y） IP段（x.y.z.0/24） 多个IP（10.x.y.z,11.x.y.z,12.x.y.z）',
                        element3 : '端口格式：单个端口（22） 端口范围（10/20） 全部端口（-1/-1）',
                        element4 : '优先级：范围1-99 数字越小优先级越高',
                        FirstColumn  : '协议类型',
                        SecondColumn : '授权对象',
                        ThirdColumn : '端口范围',
                        FourthColumn : '策略',
                        FifthColumn : '备注',
                        SixthColumn : '优先级',
                        SeventhColumn : '操作',
                        eg1 : '例如:0.0.0.0/24',
                        eg2 : '请填写',
                        eg3 : '例如:1~99',
                        Button1 : '删除',
                        Button2 : '添加',
                        Button3 : '取消',
                        Button4 : '确认',
                    },
                    Button1 : '新增规则',
                    editButton : {
                        title : '编辑规则',
                        element1 : '所有IP（0.0.0.0）、单个IP（10.x.x.y）、IP段（x.y.z.0/24）、多个IP（10.x.y.z、11.x.y.z、12.x.y.z）',
                        element2 : '请键入策略名称',
                        element3 : '单端口（22）、端口范围（10/20）、所有端口（-1/-1）',
                        element4 : '从1到99',
                        FirstColumn  : '协议类型',
                        SecondColumn : '授权对象',
                        ThirdColumn : '端口范围',
                        FourthColumn : '策略',
                        FifthColumn : '备注',
                        SixthColumn : '优先级',
                        SeventhColumn : '操作',
                        Button1 : '删除',
                        Button2 : '添加',
                        Button3 : '取消',
                        Button4 : '确认',
                    },
                    delButton : {
                        title : '删除规则',
                        element1 : '你确定删除?',
                        element2 : '条规则选择',
                        element3 : '为了避免影响实例之间的网络通信，请仔细操作。',
                        element4 : '规则选择：',
                        Button3 : '取消',
                        Button4 : '删除',
                    },
                },
                RelatedInstances : {
                    title : '关联实例',
                    empty : '请将实例添加到实例列表中的安全组',
                    FirstColumn  : '实例ID/名称',
                    SecondColumn : 'IP地址',
                    ThirdColumn : '机房',
                    FourthColumn : {
                        title : '操作',
                        removeout : '移除',
                    },
                    Button1 : '新增关联',
                    footer : {
                        title : '批量操作',
                        Delete : '从安全组中移除',
                    },
                },
                AddSecurityGroup : {
                    title : '添加到安全组',
                    element1 : '所选安全组',
                    element2 : '请搜索实例名/ID/IP',
                    element3 : '实例ID/实例名',
                    element4 : '公网IP',
                    element5 : '所属内网',
                    Button1 : '取消',
                    Button2 : '确定',
                },
                RemoveInt :{
                    title : '移除',
                    element1 : '你确定要从安全组中移除',
                    element2 : '个实例?',
                    element3 : ' ',
                    element4 : '被选中的实例列表',
                    element5 : '个实例被选中',
                    element6 : '为了避免影响实例之间的网络通信，请小心操作。',
                    Button1 : '取消',
                    Button2 : '确定',
                },
            },
            footer : {
                title : '批量操作',
                Delete : '删除',
            },
        },
        IP : {
            searchHolder : '搜索IP',
            FirstColumn  : 'IP',
            SecondColumn : {
                title : '状态',
                Available : '空闲',
                // ToBeAssigned : '待分配',
                // Unbound : '未绑定',
                // Bound : '已绑定',
                Inuse : '正在使用',
                Disabled : '已禁用',
                // Deleted : '已删除',
                Expired : '过期',
            },
            ThirdColumn : '机房',
            FourthColumn : '所属服务器',
            FifthColumn : '带宽值',
            SixthColumn : {
                title : '购买方式',
                // Unsold : '未售',
                Package : '配套',
                Separately : '独立购买',
            },
            SeventhColumn : '费用（美元/月）',
            EighthColumn : '到期时间',
            addip :{
                title : '添加保留IP',
                element1 : '相关实例',
                element2 : '请选择要装载的实例',
                element3 : '数量:',
                Charges : '费用',
                Button1 : '取消',
                Button2 : '购买',
            }
        },
        Intranets : {
            searchHolder : '搜索名称',
            FirstColumn  : '机房',
            SecondColumn : '名称',
            ThirdColumn : '创建时间',
            FourthColumn : {
                title : '操作',
                view : '查看',
                Edit : '编辑'
            },
            viewlist : {
                title : '内网',
                FirstColumn  : '机房',
                SecondColumn : '名称',
                ThirdColumn : '配置',
                FourthColumn : 'IP',
            },
            addpop : {
                title : '添加内网',
                FirstColumn  : '内网名称',
                SecondColumn : '地区：',
                element1 : '每个用户只能在区域中设置一个内网',
                Button1 : '取消',
                Button2 : '确认',
            },
            editpop : {
                title : '编辑内网',
            },
            element1 : '安全隔离',
            element2 : '基于亿速云构建出隔离的网络环境，不同裸金属保证二层逻辑隔离',
            element3 : '灵活',
            element4 : '软件定义网络，按需配置网络，可自定义IP 地址范围与路由表等',
            element5 : '完全免费',
            element6 : '基于亿速云免费实现完全隔离的云上专有网络',
            element7 : '适用范围',
            element8 : '相同区域线路的裸金属可通过内网互相访问，不同区区域的暂不可通过内网互相访问',
        },
        error : {
            renewpop:{
                error1 : '请输入登录密码',
                error2 : '请等待价格计算出来',                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                error3 : '续费时长必须大于0',
                error4 : '请至少选择1个实例',
            },
            startpop:{
                error1 : '无法启动一个或多个实例',
            },
            restartpop:{
                error1 : '无法重启一个或多个实例',
            },
            stoppop:{
                error1 : '无法关机一个或多个实例',
            },
            buypop:{
                error1 : '请输入登录密码',
                error2 : '创建订单失败',
                error3 : '请选择支付方式',
            },
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/bms.js